import React, { useState, useEffect } from 'react';
import { Container } from 'vendors/semantic-ui';

import { routes } from 'config';
import { readCMSValue, getDefault } from 'modules/shared-cms/utils';
import { buildCMSValueList } from 'modules/shared-cms-advanced/utils';
import {
    DescriptionContainer,
    LabelTitle,
    TitleBlocContainer,
    ThumbList,
    PreFooterBloc,
    RibbonBlocContainer,
    MentionContainer,
} from 'modules/shared-cms-advanced/components';

import { SignProps } from './sign-type';

import enhancer from './sign-enhancer';

import styles from './sign-page.module.css';

const InnerSignPage: React.FC<SignProps> = React.memo(
    ({ brands, content, universes, sessionData, updateSessionData }: SignProps) => {
        const { ...rest } = content.length > 0 ? content[0].data : null;
        const { ribbonList, mention, preFooterPictureList, preFooterColor } = { ...rest };
        const preFooterBackgroundColor = getDefault(readCMSValue(preFooterColor), '');

        const universesCopy = buildCMSValueList(universes, 'TOUS LES UNIVERS', true);
        const initialUniverseValue = sessionData ? sessionData.universeSign : universesCopy[0].value;

        const [selectedUniverse] = useState(initialUniverseValue);
        const [brandList, setBrandList] = useState(brands);

        useEffect(() => {
            // Sauvegarde
            updateSessionData({ universeSign: selectedUniverse });

            setBrandList(
                brands
                    .filter(brand => {
                        return (
                            selectedUniverse === '' ||
                            getDefault(readCMSValue(brand.data.universe), []).findIndex(
                                u => u.id === selectedUniverse,
                            ) > -1
                        );
                    })
                    .map(b => {
                        const currentBrand = b;
                        if (currentBrand && currentBrand.data) {
                            currentBrand.data.urlDirectory = {
                                path: routes.catalogue.brand,
                                isRoot: true,
                            };
                        }
                        return currentBrand;
                    }),
            );
        }, [selectedUniverse, brands, updateSessionData]);

        return (
            <React.Fragment>
                <div className={styles.titleBlocSection}>
                    <TitleBlocContainer {...rest} />
                </div>
                {ribbonList && ribbonList.iv.length > 0 && (
                    <Container>
                        <RibbonBlocContainer {...rest} />
                    </Container>
                )}
                <div className={styles.descriptionSection}>
                    <Container>
                        <LabelTitle {...rest} />
                        <div className={styles.descriptionText}>
                            <DescriptionContainer {...rest} />
                        </div>
                    </Container>
                </div>
                <div className={styles.brandListSection}>
                    <Container>
                        {brandList && brandList.length > 0 ? (
                            <div>
                                <div className={styles.results}>
                                    {brandList.length} MARQUE{brandList.length > 1 ? 'S' : ''}
                                </div>
                                <ThumbList thumbs={brandList} useBrandId />
                            </div>
                        ) : (
                            <div className={styles.noResults}>
                                Aucune marque n&apos;est disponible dans cette sélection pour l&apos;instant. Nous vous
                                invitons à vous rapprocher de l&apos;équipe Printemps Listes de votre enseigne qui saura
                                vous accompagner dans votre recherche.
                            </div>
                        )}
                    </Container>
                </div>
                {mention && (
                    <Container className={styles.mentionBloc}>
                        <MentionContainer {...rest} mention={mention} />
                    </Container>
                )}
                {preFooterPictureList && preFooterPictureList.iv.length > 0 && preFooterPictureList.iv.length <= 3 && (
                    <div className={styles.preFooterBlocMin} style={{ backgroundColor: preFooterBackgroundColor }}>
                        <PreFooterBloc preFooterPicturelist={preFooterPictureList.iv} />
                    </div>
                )}
                {preFooterPictureList && preFooterPictureList.iv.length > 0 && preFooterPictureList.iv.length > 3 && (
                    <div className={styles.preFooterBlocMax} style={{ backgroundColor: preFooterBackgroundColor }}>
                        <PreFooterBloc preFooterPicturelist={preFooterPictureList.iv} />
                    </div>
                )}
            </React.Fragment>
        );
    },
);
export const SignPage = enhancer(InnerSignPage);
